module.exports = __webpack_public_path__ + "static/hole-52d46d97485ec6355ec2280bc5e0aada.jpg";